import { createContext } from 'react'
import { ArtboardCropPosition } from './types'

type CreationToolsArtboardContextProps = {
    frameCount: number
    renderingContext: CanvasRenderingContext2D | null
    canvasScale: number
    crop?: ArtboardCropPosition
    setCrop: (crop?: ArtboardCropPosition) => void
}

export const CreationToolsArtboardContext = createContext({} as CreationToolsArtboardContextProps)
